import { propEq } from 'ramda'

export const isTitle = propEq('__typename', 'Title')
export const isSeries = propEq('__typename', 'Series')
export const isEpisode = propEq('__typename', 'Episode')
export const isSeason = propEq('__typename', 'Season')
export const isVideoExtra = propEq('__typename', 'VideoExtra')
export const isScreen = propEq('__typename', 'Screen')
